<template>
    <v-flex xs12>
        <v-container grid-list-lg>
            <v-layout row wrap>
                <v-flex xs12>
                    <h4 class="primary--text">Valores Transportados</h4>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-text-field label="Valor total transportado por mês"
                    class="overflow-label"
                    :value="toMoneyString(model.valorTransportadoMes)"
                    disabled></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-text-field label="Quantidade de viagens por mês"
                    class="overflow-label"
                    :value="model.quantidadeViagensMes"
                    disabled></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-text-field label="Maior valor embarcado"
                    class="overflow-label"
                    :value="toMoneyString(model.maiorValorEmbarcado)"
                    disabled></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <h4 class="primary--text">Percentual de veículos</h4>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-text-field label="Próprios"
                    class="overflow-label"
                    :value="toPercentString(model.percentualVeiculoProprio)"
                    disabled></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-text-field label="Agregados"
                    class="overflow-label"
                    :value="toPercentString(model.percentualVeiculoAgregado)"
                    disabled></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-text-field label="Autônomos"
                    class="overflow-label"
                    :value="toPercentString(model.percentualVeiculoAutonomo)"
                    disabled></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <h4 class="primary--text">Rotas de maior frequência</h4>
                </v-flex>
                <v-flex xs12 v-if="estados.length > 0">
                    <v-data-table :headers="cabecalhoGridRotas"
                    hide-actions
                    :items="model.rotas"
                    no-data-text="Nenhuma rota foi adicionada">
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ buscaSiglaEstado(props.item.idEstadoOrigem) }}</td>
                            <td class="text-xs-left">{{ buscaSiglaEstado(props.item.idEstadoDestino) }}</td>
                            <td class="text-xs-left">{{ toPercentString(props.item.percentual) }}</td>
                        </template>
                    </v-data-table>
                </v-flex>
                <v-flex xs12>
                    <h4 class="primary--text">Mercadorias Transportadas</h4>
                </v-flex>
                <v-flex xs12>
                    <v-data-table :headers="cabecalhoGridMercadorias"
                    hide-actions
                    :items="model.mercadorias"
                    no-data-text="Nenhuma mercadoria foi adicionada">
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.mercadoria.descricao }}</td>
                            <!-- <td class="text-xs-left">{{ toMoneyString(props.item.valorMedio) }}</td> -->
                            <td class="text-xs-left">{{ toPercentString(props.item.percentual) }}</td>
                        </template>
                    </v-data-table>
                </v-flex>
                <v-flex xs12><h4 class="primary--text">Realiza transporte?</h4></v-flex>
                <v-flex xs12 sm4>
                    <v-checkbox disabled color="primary" id="chkDadosOperacionaisFluvial" v-model="model.fluvial" label="Fluvial"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-checkbox disabled color="primary" id="chkDadosOperacionaisMudanca" v-model="model.mudanca" label="Mudança"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-checkbox disabled color="primary" id="chkDadosOperacionaisContainer" v-model="model.container" label="Container"></v-checkbox>
                </v-flex>
            </v-layout>
        </v-container>
    </v-flex>
</template>

<script>
import CustomFormat from '@/helpers/custom-format'
import axios from 'axios'

export default {
  name: 'dadosoperacionais',
  props: ['model'],
  data: () => {
    return {
        estados: [],
        cabecalhoGridMercadorias: [
            {text: 'Mercadoria', value: 'mercadoria'},
            //{text: 'Valor médio', value: 'valorMedio'},
            {text: 'Percentual', value: 'percentual'}
        ],
        cabecalhoGridRotas: [
            {text: 'Origem', value: 'origem'},
            {text: 'Destino', value: 'destino'},
            {text: 'Percentual', value: 'percentual'}
        ],
        model: {
          fluvial: null,
          mudanca: null,
          container: null
        }
    }
  },
  mounted: function () {
      this.carregaEstados();
  },
  methods: {
    carregaEstados: function () {
        const self = this;
        axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosEstados`)
        .then((response) => {
            self.estados = response.data.sort((a, b) => { return a.sigla.localeCompare(b.sigla) });
        });
    },
    buscaSiglaEstado: function (idEstado) {
        return this.estados.find((x) => { return x.id == idEstado}).sigla;
    },
    toMoneyString: function (val) {
        return CustomFormat.toMoneyString(val);
    },
    toPercentString: function (val) {
        return CustomFormat.toPercentString(val);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/DadosOperacionais.vue